'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InterpolateVariables = exports.DefineVariables = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _deep = require('helpers/deep');

var _object = require('helpers/object');

var _verify = require('helpers/verify');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CONTEXT_VARIABLE_REGEX = /\{([^{}]*)\}/g;

var normalizeVariable = function normalizeVariable(variable) {
  return (variable || '').toUpperCase();
};
var normalizeKeys = function normalizeKeys(object) {
  return (0, _object.transformKeys)(normalizeVariable, (0, _object.transformValues)(function (val) {
    return (0, _verify.isObject)(val) ? normalizeKeys(val) : val;
  }, object));
};

var determineValue = function determineValue(valueByVariable, match, variable) {
  return (0, _deep.deepExtract)(normalizeVariable(variable), valueByVariable, match);
};

var interpolateVariables = function interpolateVariables(valueByVariable, text) {
  return (text || '').replace(CONTEXT_VARIABLE_REGEX, determineValue.bind(null, valueByVariable));
};

var ContextVariables = _react2.default.createContext({});

var DefineVariables = exports.DefineVariables = function DefineVariables(_ref) {
  var children = _ref.children,
      variables = _ref.variables;
  return _react2.default.createElement(
    ContextVariables.Consumer,
    null,
    function (contextVariables) {
      return _react2.default.createElement(
        ContextVariables.Provider,
        {
          value: (0, _extends3.default)({}, contextVariables, normalizeKeys(variables || {}))
        },
        children
      );
    }
  );
};

var InterpolateVariables = exports.InterpolateVariables = function InterpolateVariables(_ref2) {
  var children = _ref2.children;
  return _react2.default.createElement(
    ContextVariables.Consumer,
    null,
    function (contextVariables) {
      return children(interpolateVariables.bind(null, contextVariables));
    }
  );
};

DefineVariables.propTypes = {
  children: _propTypes2.default.node.isRequired,
  variables: _propTypes2.default.object
};

InterpolateVariables.propTypes = {
  children: _propTypes2.default.func.isRequired
};